
import React from 'react'
import RoleListTable from './Components/RoleListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import {HeadingOne} from "Common/Custom/HeadingOne";

const RoleList = () => {
  return (
    <PageBody
     card={true}
     headerchildren={
        <>
        <HeadingOne>Role List</HeadingOne>
        <AddItemBtn url="role-add" title="Create Role" />
        </>
       }>

      {/* Table section */}
      <div className="col-12">
        <RoleListTable />
      </div>
    </PageBody>
  );
};

export default RoleList;
